module.exports = __webpack_public_path__ + "img/re-result-6.9a0ee0f5.jpg";